import React, { FC } from "react";

import { TimePeriod } from "../../../hooks/useDetectTimePeriod";
import { useInvoiceFiltersController } from "../../../hooks/useInvoiceFiltersController";
import { InvoiceFiltersBase } from "./InvoiceFiltersBase";

type Props = {
  controller: ReturnType<typeof useInvoiceFiltersController>;
};

export const InvoicesListFilters: FC<Props> = ({ controller }) => {
  return (
    <InvoiceFiltersBase
      showFilters={["status", "assignee", "client", "invoice-date", "label"]}
      filter={controller.filter}
      setFilter={controller.setFilter}
      filterByStatus={controller.filterByStatus}
      setFilterByStatus={controller.setFilterByStatus}
      filterByUser={controller.filterByUser}
      setFilterByUser={controller.setFilterByUser}
      filterByContact={controller.filterByContact}
      setFilterByContact={controller.setFilterByContact}
      filterByLabel={controller.filterByLabel}
      setFilterByLabel={controller.setFilterByLabel}
      usersOptions={controller.usersOptions}
      clientOptions={controller.clientOptions}
      labelOptions={controller.labelOptions}
      isLoadingUsers={controller.isLoadingUsers}
      isLoadingContacts={controller.isLoadingContacts}
      searchClients={controller.searchClients}
      setSearchClients={controller.setSearchClients}
      defaultTimePeriod={TimePeriod.YTD}
      billing
    />
  );
};
